<template>
  <section class="simulados">
    <div class="simulado-novo box-branco container" ref="simuladoview">
      <h2 class="mb-4">
        <i class="fas fa-list-ul"></i>Criar simulado personalizado <a href="#" class="ml-1" v-b-tooltip.hover title="Veja como criar um simulado"><i class="fas fa-question-circle"></i></a>
      </h2>
      <div class="novosim">
        <div class="colunas-novosim d-flex">
          <div v-if="categorias && categorias.length">
            <h3>Categorias</h3>
            <ul class="list-group">
              <li v-for="categoria in categorias" class="list-group-item" :class="[categoriasEscolhidas.includes(categoria) ? 'boxSelected': '']">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :value="categoria" :id="`cat-${categoria.id}`" v-model="categoriasEscolhidas" @change="changeCategoria($event, categoria)">
                  <label class="custom-control-label" :for="`cat-${categoria.id}`">{{ categoria.nome }}</label>
                </div>
                <a href="javascript:void(0)" @click="exibirDisciplinasCategoria(categoria)"><i class="fas fa-chevron-circle-right"></i></a>
              </li>
            </ul>
          </div>
          <div v-if="disciplinas && disciplinas.length">
            <h3>Disciplinas</h3>
            <ul class="list-group">
              <li v-for="(disciplina, index) in disciplinas" class="list-group-item" :class="[disciplinasEscolhidas.includes(disciplina)? 'boxSelected': '']">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :id="`disciplina${disciplina.id}-${index}`" :value="disciplina" v-model="disciplinasEscolhidas" @change="changeDisciplina($event, disciplina)">
                  <label class="custom-control-label" :for="`disciplina${disciplina.id}-${index}`">{{ disciplina.nome }}</label>
                </div>
                <a href="javascript:void(0)" @click="exibirCursosDisciplina(disciplina)"><i class="fas fa-chevron-circle-right"></i></a>
              </li>
            </ul>
          </div>
          <div v-if="cursos && cursos.length">
            <h3>Cursos</h3>
            <ul class="list-group">
              <li v-for="(curso, index) in cursos" class="list-group-item" :class="[cursosEscolhidos.includes(curso) ? 'boxSelected': '']">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :value="curso" :id="`curso${curso.id}-${index}`" v-model="cursosEscolhidos" @click="changeCurso($event, curso)">
                  <label class="custom-control-label" :for="`curso${curso.id}-${index}`">{{ curso.nome }}</label>
                </div>
                <a href="javascript:void(0)" @click="exibirModulosCurso(curso)"><i class="fas fa-chevron-circle-right"></i></a>
              </li>
            </ul>
          </div>
          <div v-if="modulos && modulos.length">
            <h3>Módulos</h3>
            <ul class="list-group">
              <li v-for="(modulo, index) in modulos" class="list-group-item" :class="[modulosEscolhidos.includes(modulo) ? 'boxSelected': '']">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :value="modulo" :id="`modulo${modulo.id}-${index}`" v-model="modulosEscolhidos" @change="changeModulo($event, modulo)">
                  <label class="custom-control-label" :for="`modulo${modulo.id}-${index}`">{{ modulo.nome }}</label>
                </div>
                <a href="javascript:void(0)" @click="exibirLicoesModulo(modulo)"><i class="fas fa-chevron-circle-right"></i></a>
              </li>
            </ul>
          </div>
          <div v-if="licoes && licoes.length">
            <h3>Lições</h3>
            <ul class="list-group">
              <li v-for="(licao, index) in licoes" class="list-group-item" :class="[licoesEscolhidas.find(l => l.id === licao.id) ? 'boxSelected': '']">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :value="licao" :id="`licao${licao.id}-${index}`" v-model="licoesEscolhidas">
                  <label class="custom-control-label" for="`licao${licao.id}-${index}`">{{ licao.nome }}</label>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <div class="tags-novosim mt-4" v-if="tagsEscolhas && tagsEscolhas.length">
        <span v-for="tag in tagsEscolhas">
          {{ tag }} <a href="#"><i class="fas fa-times"></i></a>
        </span>
      </div>
      <div class="rodape-sim">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="nome-sim">Nome do simulado</label>
              <input type="text" class="form-control" id="nome-sim" placeholder="" v-model="nomeSimulado">
            </div>
          </div>
          <div class="col-12 col-md-2 text-center">
            <div class="num-questoes">
              <span>{{ quantidadeQuestoesSelecionadas }}</span>
              <span>Questões</span>
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="form-group">
              <label for="maxQuestoes">Máx. Questões</label>
              <input type="text" class="form-control" id="maxQuestoes" placeholder="" v-model="maxQuestoes">
            </div>
          </div>
          <div class="col-12 col-md-4 text-right">
            <a href="/simulados" class="btn btn-novosim">Criar simulado</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SimuladoAPI from '@/api/simulado-api'

export default {
  name: 'NovoSimuladoView',
  data () {
    return {
      categorias: [],
      disciplinas: [],
      cursos: [],
      modulos: [],
      licoes: [],
      categoriasEscolhidas: [],
      disciplinasEscolhidas: [],
      cursosEscolhidos: [],
      modulosEscolhidos: [],
      licoesEscolhidas: [],
      tagsEscolhas: [],
      nomeSimulado: '',
      quantidadeQuestoesSelecionadas: 0,
      maxQuestoes: null
    }
  },
  mounted () {
    const loader = this.$loading.show({ isFullPage: false, loader: 'dots', container: this.$refs.simuladoview })

    SimuladoAPI.listarEstruturaCriacaoSimulado().then(data => {
      this.categorias = data.categorias
      loader.hide()
    })
  },
  methods: {
    exibirDisciplinasCategoria: function (categoria) {
      this.disciplinas = [...categoria.disciplinas]
      this.cursos = []
      this.modulos = []
      this.licoes = []
    },

    exibirCursosDisciplina: function (disciplina) {
      this.cursos = [...disciplina.cursos]
      this.modulos = []
      this.licoes = []
    },

    exibirModulosCurso: function (curso) {
      this.modulos = [...curso.modulos]
      this.licoes = []
    },

    exibirLicoesModulo: function (modulo) {
      this.licoes = modulo.licoes
    },

    changeCategoria: function (event, categoria) {
      if (event.target.checked) {
        categoria.disciplinas.forEach(item => {
          this.disciplinasEscolhidas.push(item)
          this.changeDisciplina(event, item)
        })
      } else {
        this.disciplinasEscolhidas = this.disciplinasEscolhidas.filter(item => {
          const disciplinaRemovida = !categoria.disciplinas.includes(item)
          if (!disciplinaRemovida) {
            this.changeDisciplina(event, item)
          }
          return disciplinaRemovida
        })
      }
    },

    changeDisciplina: function (event, disciplina) {
      if (event.target.checked) {
        disciplina.cursos.forEach(item => {
          this.cursosEscolhidos.push(item)
          this.changeCurso(event, item)
        })
      } else {
        this.cursosEscolhidos = this.cursosEscolhidos.filter(item => {
          const cursoRemovido = !disciplina.cursos.includes(item)
          if (!cursoRemovido) {
            this.changeCurso(event, item)
          }
          return cursoRemovido
        })
      }
    },

    changeCurso: function (event, curso) {
      if (event.target.checked) {
        curso.modulos.forEach(item => {
          this.modulosEscolhidos.push(item)
          this.changeModulo(event, item)
        })
      } else {
        this.modulosEscolhidos = this.modulosEscolhidos.filter(item => {
          const moduloRemovido = !curso.modulos.includes(item)
          if (!moduloRemovido) {
            this.changeModulo(event, item)
          }
          return moduloRemovido
        })
      }
    },

    changeModulo: function (event, modulo) {
      if (event.target.checked) {
        modulo.licoes.forEach(item => {
          this.licoesEscolhidas.push(item)
        })
      } else {
        this.licoesEscolhidas = this.licoesEscolhidas.filter(item => !modulo.licoes.includes(item))
      }
    }
  }
}
</script>

<style scoped>
  .boxSelected {
    background-color: rgb(54, 57, 83); color: rgb(255, 255, 255);
  }
</style>
